export const transformRecepcion = (recepcion) => {
    return {
        id: recepcion.id, // este es el detalle_compra_id, no el id de la recepcion
        id_ingreso: recepcion.id_ingreso, // este es el id de la recepcion
        fecha_entrada: recepcion.fecha_entrada,
        materia_prima: recepcion.materia_prima,
        finca: recepcion.finca,
        vehiculo: recepcion.vehiculo,
        acopio: recepcion.acopio,
        kilos_humedos: recepcion.kilos_humedos,
        productos: recepcion.productos,
        ...recepcion.resumen_calidad, // drc_laboratorio, kilos_secos_laboratorio, etc
    };
};

export const fincasCellContent = (detalles) => {
    if (!detalles || detalles.length === 0) return "";

    return [
        ...new Set(detalles.map((detalle) => detalle.finca.id).filter(Boolean)),
    ]
        .sort((a, b) => a - b)
        .join(", ");
};

export const getVehiculoLabel = (vehiculo) => {
    if (!vehiculo) return "";

    let labelItems = [];
    if (vehiculo.tipo_vehiculo && vehiculo.tipo_vehiculo.nombre) {
        labelItems.push(vehiculo.tipo_vehiculo.nombre);
    }
    if (vehiculo.placa) {
        labelItems.push(vehiculo.placa);
    }
    return labelItems.join(" ");
};

// Para traslados en proceso y finalizados
export const getAnalisisFromItem = (item) => {
    return item.analisis && item.analisis.length > 0 ? item.analisis[0] : {};
};

export const getKgSecosLabFromItem = (analisis_lab = {}, dato_actual) => {
    return dato_actual.kilos_humedos * analisis_lab.drc_final || 0;
};

// Para detalles de traslado
export const getMateriaPrimaFromDetalles = (detalles) => {
    if (!detalles || detalles.length === 0) return "";
    if (!detalles[0]) return "";

    const materiaPrima = detalles[0].materia_prima;
    if (!materiaPrima) return "";

    return materiaPrima;
};
